'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getEndpoint = require('../get-endpoint');

var _getEndpoint2 = _interopRequireDefault(_getEndpoint);

var _config = require('../config');

var _dataProvider = require('../data-provider');

var _dataProvider2 = _interopRequireDefault(_dataProvider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Gets the details of a promotion matching the supplied nui
 * @note: due to the way this endpoint is implemented in squiz, an error will never be sent on the response body.
 * @param {GetPromoCodeParamsType} params The function parameters
 * @param {TunnelType} params.tunnel The request tunnel
 * @param {String} [params.nui] The promotion identifier passed from the component
 * @returns {Promise<PromoDataRecordType>} A Record containing the promotion data
 */
exports.default = function () {
    var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(params) {
        var tunnel, nui, endpoint, proxyAgent, response;
        return _regenerator2.default.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        tunnel = params.tunnel, nui = params.nui;
                        endpoint = (0, _getEndpoint2.default)('squiz', '/sportsbook/_designs/js/promo-codes-feeds/nui-list');
                        proxyAgent = (0, _config.getProxy)('squiz');
                        _context.next = 5;
                        return (0, _dataProvider2.default)(endpoint, tunnel, {
                            agent: proxyAgent
                        });

                    case 5:
                        response = _context.sent;
                        return _context.abrupt('return', response.nui[nui]);

                    case 7:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, this);
    }));

    function getPromoCodes(_x) {
        return _ref.apply(this, arguments);
    }

    return getPromoCodes;
}();
//# sourceMappingURL=promoCodes.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/data-provider/dist/main/promo-codes/promoCodes.js
// module id = 456
// module chunks = 0